import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const ProjectUsers = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { ProjectUsers, defaultState };
